// ----------------------------------------------------------------------

export default function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}
const ROOT_PATH = '/';
const ROOTS_DASHBOARD = '/app';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: '/login',
  logout: '/logout',
  register: '/register'
};

export const PATH_PUBLIC = {
  root: ROOT_PATH,
  product: {
    list: path(ROOT_PATH, 'product'),
    detail: (id: any) => path(ROOT_PATH, `product/${id}`),
    checkout: path(ROOT_PATH, 'product/checkout'),
  },
}

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  one: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/one') : path(`${ROOTS_DASHBOARD}`, '/one'),
  two: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/two') : path(`${ROOTS_DASHBOARD}`, '/two'),
  product: {
    list: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/product') : path(`${ROOTS_DASHBOARD}`, '/product'),
    detail: (id: any, routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/product/${id}/detail`) : path(`${ROOTS_DASHBOARD}`, `/product/${id}/detail`),
    edit: (id: any, routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/product/${id}/edit`) : path(`${ROOTS_DASHBOARD}`, `/product/${id}/edit`),
  },
  book: {
    list: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/book') : path(`${ROOTS_DASHBOARD}`, '/book'),
    new: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/book/new') : path(`${ROOTS_DASHBOARD}`, '/book/new'),
    edit: (id: any, routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/book/${id}/edit`) : path(`${ROOTS_DASHBOARD}`, `/book/${id}/edit`),
    detail: (id: any, routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/book/${id}/detail`) : path(`${ROOTS_DASHBOARD}`, `/book/${id}/detail`),

  },
  invoice: {
    list: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/invoice') : path(`${ROOTS_DASHBOARD}`, '/invoice'),
    new: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/invoice/new') : path(`${ROOTS_DASHBOARD}`, '/invoice/new'),
    edit: (id: any, routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/invoice/${id}/edit`) : path(`${ROOTS_DASHBOARD}`, `/invoice/${id}/edit`),
    detail: (id: any, routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/invoice/${id}/detail`) : path(`${ROOTS_DASHBOARD}`, `/invoice/${id}/detail`),

  },
  user: {
    list: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/user') : path(`${ROOTS_DASHBOARD}`, '/user'),
    detail: (id: any, routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/user/${id}/detail`) : path(`${ROOTS_DASHBOARD}`, `/user/${id}/detail`),
    detail2: (id: any, routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/user/detail/${id}`) : path(`${ROOTS_DASHBOARD}`, `/user/detail/${id}`),
    edit: (id: any, routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/user/${id}/edit`) : path(`${ROOTS_DASHBOARD}`, `/user/${id}/edit`),
    new: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/user/new') : path(`${ROOTS_DASHBOARD}`, '/user/new'),
  },
  organization: {
    list: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/organization') : path(`${ROOTS_DASHBOARD}`, '/organization'),
    detail: (id: any, routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/organization/${id}/detail`) : path(`${ROOTS_DASHBOARD}`, `/organization/${id}/detail`),
    edit: (id: any, routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/organization/${id}/edit`) : path(`${ROOTS_DASHBOARD}`, `/organization/${id}/edit`),
    new: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/organization/new') : path(`${ROOTS_DASHBOARD}`, '/organization/new'),
  },
  model: {
    list: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/models') : path(`${ROOTS_DASHBOARD}`, '/models'),
    detail: (id: any, routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/models/${id}/detail`) : path(`${ROOTS_DASHBOARD}`, `/models/${id}/detail`),
    edit: (id: any, routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/models/${id}/edit`) : path(`${ROOTS_DASHBOARD}`, `/models/${id}/edit`),
    new: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/models/new') : path(`${ROOTS_DASHBOARD}`, '/models/new'),
  },
  plans: {
    list: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/plans') : path(`${ROOTS_DASHBOARD}`, '/plans'),
    detail: (id: any, routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/plans/${id}/detail`) : path(`${ROOTS_DASHBOARD}`, `/plans/${id}/detail`),
    edit: (id: any, routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/plans/${id}/edit`) : path(`${ROOTS_DASHBOARD}`, `/plans/${id}/edit`),
    new: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/plans/new') : path(`${ROOTS_DASHBOARD}`, '/plans/new'),
  },
  fileUploads: {
    main: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/file-uploads') : path(`${ROOTS_DASHBOARD}`, '/file-uploads'),
    admin: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/file-upload') : path(`${ROOTS_DASHBOARD}`, '/file-upload'),
  },
  folderUploads: {
    main: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/folder-uploads') : path(`${ROOTS_DASHBOARD}`, '/folder-uploads'),
  },
  subscription: {
    myList: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/subscriptions/self') : path(`${ROOTS_DASHBOARD}`, '/subscriptions/self'),
    orgList: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/subscriptions/org') : path(`${ROOTS_DASHBOARD}`, '/subscriptions/org'),
    // detail: (id: any, routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/plans/${id}/detail`) : path(`${ROOTS_DASHBOARD}`, `/plans/${id}/detail`),
    // edit: (id: any, routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/plans/${id}/edit`) : path(`${ROOTS_DASHBOARD}`, `/plans/${id}/edit`),
    // new: (routePrefix?: string) =>  routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/plans/new') : path(`${ROOTS_DASHBOARD}`, '/plans/new'),
  },
  themeSettings: {
    settings: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/theme-settings`) : path(`${ROOTS_DASHBOARD}`, `/theme-settings`)
  },
  customEmails: {
    send: path(ROOTS_DASHBOARD, `/custom-email`)
  },
  accountSettings: {
    settings: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/settings/user`) : path(`${ROOTS_DASHBOARD}`, `/settings/user`)
  },
  dashboard: {
    dash: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/dashboard`) : path(`${ROOTS_DASHBOARD}`, `/dashboard`)
  },
  home: {
    home: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/home`) : path(`${ROOTS_DASHBOARD}`, `/home`)
  },
  upload: {
    upload: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/upload`) : path(`${ROOTS_DASHBOARD}`, `/upload`)
  },
  notification: {
    list: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/notification/list`) : path(`${ROOTS_DASHBOARD}`, `/notification/list`)
  },
  threshold: {
    detail: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/threshold`) : path(`${ROOTS_DASHBOARD}`, `/threshold`)
  },
  transaction: {
    list: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/transaction`) : path(`${ROOTS_DASHBOARD}`, `/transaction`),
    detail: (id: any, routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/transaction/${id}/detail`) : path(`${ROOTS_DASHBOARD}`, `/transaction/${id}/detail`),
  },
  orgTransaction: {
    list: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/orgTransaction`) : path(`${ROOTS_DASHBOARD}`, `/orgTransaction`),
  },
  transactionSync:{
     list: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/transactionSync`) : path(`${ROOTS_DASHBOARD}`, `/transactionSync`),
  },
  modelTransaction:{
    list: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/modelTransaction`) : path(`${ROOTS_DASHBOARD}`, `/modelTransaction`),
  },
  compression: {
    list: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/compression`) : path(`${ROOTS_DASHBOARD}`, `/compression`),
  },
  auditLog: {
    list: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/audit-trial`) : path(`${ROOTS_DASHBOARD}`, `/audit-trial`)
  },
  pushNotification: {
    notification: path(ROOTS_DASHBOARD, '/push_notification'),
  },
  dataTraining: {
    list: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/data-training`) : path(`${ROOTS_DASHBOARD}`, `/data-training`),
    newTraining: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/data-training/new') : path(`${ROOTS_DASHBOARD}`, '/data-training/new'),
  },
  fileManager: {
    main: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/file-manager/personal`) : path(`${ROOTS_DASHBOARD}`, `/file-manager/personal`),
    sharedWith: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/file-manager/shared`) : path(`${ROOTS_DASHBOARD}`, `/file-manager/shared`),
    folder: (pathString: string, routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/file-manager/personal?path=${pathString}`) : path(`${ROOTS_DASHBOARD}`, `/file-manager/personal?path=${pathString}`),
    sharedFolder: (pathString: string, routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/file-manager/shared?path=${pathString}`) : path(`${ROOTS_DASHBOARD}`, `/file-manager/shared?path=${pathString}`),
    bin: (routePrefix?: string,) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, `/file-manager/bin`) : path(`${ROOTS_DASHBOARD}`, `/file-manager/bin`),
  },
  customTemplates: {
    // list: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/user') : path(`${ROOTS_DASHBOARD}`, '/user'),
    create: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/custom-templates') : path(`${ROOTS_DASHBOARD}`, '/custom-templates')
  },
  templateCategories: {
    create: (routePrefix?: string) => routePrefix ? path(`/${routePrefix}${ROOTS_DASHBOARD}`, '/create-template-categories') : path(ROOTS_DASHBOARD, `/create-template-categories`)
  },
};
